import type { Work } from '../data/types';

/**
 * What the crew will draw from, as the backend picks it (kindling-render.service
 * pickIdeas / wordsOf): the first lines, or else the fields together, the pairs,
 * the text, the emoji. Shown in the darkroom while they work, so the words on the
 * print are the words the picture is made of.
 */
export function wordsForCrew(work: Work): string[] {
  // "Who are you?" is a character drawn from the pictures, not from any words (backend characterIdea)
  if (work.made || work.selfie || work.drawn) {
    const fromWork = !!work.made?.some((m) => m.photo);
    if (work.selfie || work.drawn) return [fromWork ? 'You, drawn from your work' : 'You, as your character'];
    return [fromWork ? 'Your character, drawn from your work' : 'Your character'];
  }
  const s = (v: unknown) => String(v ?? '').replace(/\s+/g, ' ').trim();
  const lines = (work.lines || []).map(s).filter(Boolean).slice(0, 2).map((l) => l.slice(0, 160));
  if (lines.length) return lines;
  const fields = Object.values(work.fields || {}).map(s).filter(Boolean);
  if (fields.length) return [fields.join(' · ').slice(0, 160)];
  const pairs = (work.pairs || []).map((p) => [s(p.name), s(p.sub)].filter(Boolean).join(': ')).filter(Boolean);
  if (pairs.length) return pairs.slice(0, 2).map((x) => x.slice(0, 160));
  const text = s(work.text);
  if (text) return [text.slice(0, 160)];
  const emoji = (work.emoji || []).map(s).filter(Boolean).join(' ');
  return emoji ? [emoji] : [];
}
